<template>
  <div class="html-editor">
    <label v-if="labelAbove" class="html-editor__label-above">
      {{ labelAbove }}
    </label>
    <div :class="inputFieldClasses">
      <editor
        v-model="newValue"
        :tinymce-script-src="tinymceScriptSrc"
        @onInit="editorInit"
        :init="{
          width: '100%',
          height: height,
          menubar: false,
          plugins: ['advlist lists', 'fullscreen link', 'paste' + (wordCounter ? ' wordcount' : '')],
          toolbar: toolbar + ' | insertimage',
          setup: function (editor) {
            editorInst = editor;
            if (showImageBtn) {
              editor.ui.registry.addMenuButton('insertimage', {
                icon: 'image',
                tooltip: 'Insert image',
                fetch: function (callback) {
                  let options = [];
                  if (imageOptions && imageOptions.length) {
                    imageOptions.map((image) => {
                      options.push({
                        type: 'menuitem',
                        text: image.title,
                        onAction: function (_) {
                          if (image.tag !== undefined) {
                            editor.insertContent('[' + image.tag + ']' + image.figNum + '[/' + image.tag + ']');
                          } else {
                            editor.insertContent('[img]' + image.figNum + '[/img]');
                          }
                        }
                      });
                    });
                  } else {
                    options.push({
                      type: 'menuitem',
                      text: '- no images -',
                      onAction: function (_) {}
                    });
                  }
                  callback(options);
                }
              });
            }
            // wordcount
            let wordCount = 0;
            let beforeWordCount = 0;
            const countFunc = () => {
              let wordCountPlugin = editor.plugins.wordcount;
              if (wordCountPlugin) {
                wordCount = wordCountPlugin.body.getWordCount();
                if (beforeWordCount !== wordCount || wordCount == 0) {
                  $emit('wordcount', wordCount);
                  callExtFunc('wordcount', wordCount);
                  beforeWordCount = wordCount;
                }
              }
            };
            editor.on('change', countFunc);
            editor.on('input', countFunc);
            editor.on('blur', countFunc);
            editor.on('init', countFunc);
          }
        }"
        width="100%"
        :height="height"
      ></editor>
      <textarea :name="name" class="html-editor__textarea" v-model="newValue"></textarea>
    </div>
  </div>
</template>

<script>
import htmlEditorInst from "@tinymce/tinymce-vue";
import valueProp from "../../../utils/valueProp.js";
import callExternalFunction from "../../../utils/callExternalFunction";
import inStyleguidist from "../../../utils/inStyleguidist";

export default {
  name: "M4HtmlEditor",
  mixins: [valueProp, callExternalFunction],
  components: {
    editor: htmlEditorInst
  },
  data() {
    return {
      newValue: this.modelValue ? this.modelValue : this.value,
      imageOptions: [],
      editorInst: null
    };
  },
  props: {
    // moved to self-hosted version
    // apiKey: {
    //   type: String,
    //   default: "5usm95y2a4m5sa0w17kb2twuqxdjlfc4t4kn2m4ug9rhf3gj"
    // },
    toolbar: {
      type: String,
      default:
        "undo redo | bold italic underline | superscript subscript | alignleft aligncenter alignright alignjustify | bullist numlist link"
    },
    labelAbove: {
      type: String
    },
    name: {
      type: String
    },
    modelValue: {
      type: String
    },
    error: {
      type: Boolean,
      default: false
    },
    height: {
      type: Number,
      default() {
        return 200;
      }
    },
    showImageBtn: {
      type: Boolean,
      default: false
    },
    wordCounter: {
      type: Boolean,
      default() {
        return true;
      }
    }
  },
  emits: ["wordcount"],
  computed: {
    inputFieldClasses() {
      let classes = ["html-editor__field"];
      if (this.error) {
        classes.push("html-editor__field--error");
      }
      return classes;
    },
    tinymceScriptSrc() {
      if (inStyleguidist()) {
        return "//localhost:8321/tinymce/tinymce.min.js";
      }
      return document.querySelector("base").href + "tinymce/tinymce.min.js";
    }
  },
  methods: {
    addImageOptions(options) {
      this.imageOptions = options;
    },
    getWordCount() {
      if (this.editorInst) {
        let wordCountPlugin = this.editorInst.plugins.wordcount;
        return wordCountPlugin.body.getWordCount();
      }

      return 0;
    },
    editorInit(e, editor) {
      this.editorInst = editor;
    }
  }
};
</script>
